export default {
    DEFAULT_ACCOUNT_DETAILS: {
        email: '',
        subscriptionType: 'Free',
        currentPeriodEndTime: null,
        subscriptionOverdued: false,
        subscriptionCanceled: false,
        subscriptionPaused: false,
        hobbyistCredits: 0,
        professionalCredits: 0,
        fourKCredits: 0,
        freeCredits: 0,
        maxDuration: 60,
        maxFourKDuration: 60,
        pauseTimes: {},
        currentPrice: 0
    },
    // TODO: Move subscription types constants to a separate file.
    FREE_SUBSCRIPTION_TYPE: 'Free',
    ONE_TIME_SUBSCRIPTION_TYPE: 'SingleVideo',
    HOBBYIST_SUBSCRIPTION_TYPE: 'Hobbyist',
    PROFESSIONAL_SUBSCRIPTION_TYPE: 'Pro',
    LIMITLESS_SUBSCRIPTION_TYPE: 'Unlimited',
    ROUTES: [
        'create',
        'videos',
        'plans',
        'account',
        'not-found',
        'password-reset',
        'password-change',
        'not-found',
    ],
    LIVE_HOST: 'https://specterr.com'
}